import { styled } from '@mui/material'

export const Container = styled(`div`)`
  display: flex;
  min-height: ${({ theme }) => theme.spacing(6)};
  align-items: flex-end;
`
